/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Condition } from './condition';
import { MotorVehicleTariff } from './motorVehicleTariff';
import { InsurancePeriod } from './insurancePeriod';
import { InsuredVehicleRef } from './insuredVehicleRef';
import { PaymentContributor } from './paymentContributor';
import { Price } from './price';
import { MotorVehicleElementaryProduct } from './motorVehicleElementaryProduct';
import { PaymentFrequency } from './paymentFrequency';
import { PaymentMethod } from './paymentMethod';
import { MotorVehiclePackage } from './motorVehiclePackage';

/**
 * Represents a motor vehicle insurance product.   (german: Kfz Versicherung)   (bipro-kraftfahrt::KfzVersicherung)
 */
export interface MotorVehicleProduct {
  /**
   * Technical discriminator for the concrete product type.
   */
  productType: string;
  paymentMethod?: PaymentMethod;
  paymentFrequency?: PaymentFrequency;
  paymentContributor?: PaymentContributor;
  insurancePeriod?: InsurancePeriod;
  /**
   * Price affecting conditions, e.g. an incentive code.   (bipro-produktmodell::Kondition)
   */
  conditions?: Array<Condition>;
  /**
   * Calculated prices for this product.  Currency is always euro and cent.   (german: Beitrag) (bipro-produktmodell::Beitrag)
   */
  prices?: Array<Price>;
  tariff?: MotorVehicleTariff;
  package?: MotorVehiclePackage;
  /**
   * In case of damages the vehicle must be repaired in specially assigned workshops.   (german: Werkstattbindung)
   */
  assignedWorkshops?: boolean;
  /**
   * Reference to vehicles, which have the role *insured vehicle*.   (german: versichertes Fahrzeug)   (bipro-Kraftfahrt::VersichertesFahrzeug)
   */
  insuredVehicles?: Array<InsuredVehicleRef>;
  /**
   * Elementary products. Lowest level in product hierarchy.  Smallest unit for price calculation, e.g. coverage \"HAF\", \"TEI\", \"VOL\"   (bipro-produktmodell::Elementarprodukt)
   */
  elementaryProducts?: Array<MotorVehicleElementaryProduct>;
}
export namespace MotorVehicleProduct {}
